export default __webpack_public_path__ + "static/media/menu_contact.97cb1ef5.svg";